<div class="mobile-metric-ribbon">
  <div class="mobile-metric-grid px-3 py-2">
    <div class="mobile-micro-metric" *ngFor="let m of metrics">
      <span class="mobile-micro-label">{{ m.label }}</span>
      <span class="mobile-micro-value" [class.warning]="m.warning">{{ m.value }}</span>
    </div>
  </div>
</div>
